module.exports = __webpack_public_path__ + "static/media/ic_danger_dark.0613d40d.svg";